import { getStaticImageUrl } from '@utils/createImageUrl';

const AdviceSchedule = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <>
      <p className="for-lawyer-day-desc white view-on-visible">
        다음 주에는 외부 일정이 많아 상담 스케줄을&nbsp;
        {isMobile && <br />}
        미리 조정했다. 앱으로 접속해 <span className="for-lawyer-day-desc-bold">상담할 수 있는 시간만 </span>
        {isMobile && <br />}
        <span className="for-lawyer-day-desc-bold">체크</span>할 수 있어 편리했다.
      </p>
      <div className="for-lawyer-advice-mobile view-custom-on-visible">
        <img
          className="for-lawyer-manager-splash-img"
          src={getStaticImageUrl({ fileName: 'preview/mobile-splash.png' })}
        />
        {isMobile ? (
          <img
            className="for-lawyer-manager-schedule-img"
            src={getStaticImageUrl({ fileName: 'preview/schedule-setting.png' })}
          />
        ) : (
          <img
            className="for-lawyer-manager-schedule-img"
            src={getStaticImageUrl({ fileName: 'preview/schedule-setting-desktop.png' })}
          />
        )}
      </div>
    </>
  );
};

export default AdviceSchedule;
